import React, { useEffect, useState } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import IndexPage from './pages/IndexPage';
import LegalPage from './pages/Legal';
import PrivacyPage from './pages/Privacy';
import Login from './components/organisms/Login';
import { useCookies } from 'react-cookie';
import { GLOBALS } from './utils/globals';
import GoogleTagManager from './utils/google-tag-manager';
import ConstructionPage from './pages/ConstructionPage';

const Page = () => {
  const location = useLocation();
  const [cookies] = useCookies(['access', 'cookieConsent']);
  const [hasAccess, setHasAccess] = useState<boolean>(!!cookies['access']);
  const [hasTempAccess, setHasTempAccess] = useState<boolean>(location.search === '?access=1');
  const [cookieSet, setCookieSet] = useState<boolean>(false);
  const [isContruction, setIsConstruction] = useState(false);

  useEffect(() => {
    if (cookies.cookieConsent != undefined && JSON.parse(cookies.cookieConsent)) {
      GoogleTagManager.init({ gtmId: GLOBALS.gtm });
    }
  }, [cookies, cookieSet]);

  useEffect(() => {
    setHasAccess(!!cookies['access']);
  }, [cookies, hasAccess]);

  useEffect(() => {
    setHasTempAccess(location.search === '?access=1');
  }, [location.search]);

  return (
    <>
      {isContruction ? (
        <>
          <Routes>
            <Route path="/" element={<ConstructionPage />} />
          </Routes>
        </>
      ) : (
        <>
          {hasAccess || hasTempAccess ? (
            <Routes location={location}>
              <Route path="/" element={<IndexPage />} />
              <Route path="/impressum" element={<LegalPage />} />
              <Route path="/datenschutz" element={<PrivacyPage />} />
            </Routes>
          ) : (
            <Login />
          )}
        </>
      )}
    </>
  );
};

export default Page;
